import React, { Component } from 'react';
import * as actions from './actions';
import * as selectors from './selectors';
import { connect } from 'react-redux';
import { getOffersEngine } from '../../OfferEngine/OfferEngineActions';
import { LoadingBlueLarge } from 'merchant-portal-components';

function getOffers(WrappedComponent) {
  class Container extends Component {
    componentDidMount() {
      const { allOffers, getOffersEngine } = this.props;
      if (!allOffers || allOffers.length === 0) {
        getOffersEngine({
          page_number: 1,
          page_size: '1000',
          sorting_option: 'title-asc',
          search_string: '',
          has_next_page: true,
        });
      }
    }

    componentDidUpdate(prevProps) {
      const { token, getOffersEngine } = this.props;
      if (!prevProps.token && token) {
        getOffersEngine({
          page_number: 1,
          page_size: '1000',
          sorting_option: 'title-asc',
          search_string: '',
          has_next_page: true,
        });
      }
    }

    render() {
      const { requestingOffers, allOffers } = this.props;

      // 🚧 Prevent rendering before offers are ready
      if (requestingOffers) {
        return <LoadingBlueLarge />;
      }
      return <WrappedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      allOffers: state.OfferEngineReducer.allOffersEngine,
      requestingOffers: state.offers.requestingOffers,
      token: state.accountReducer.token,
    };
  }

  return connect(mapStateToProps, { ...actions, getOffersEngine })(Container);
}

export default getOffers;
